import React from 'react'
import { Feed, Divider } from 'semantic-ui-react';
import Labels from './../../../../common/Labels'
import { dispatch } from '@rematch/core';
import momentDate from './../../../../../helpers/momentDate';
import MomentTime from './../../../../common/MomentTime'
import ImageAvater from '../../../../drive/Components/ImageAvater';
class EditPutOnHoldCommentCard extends React.Component {

    async setCurrntNotes(data, clickStatus) {
        await dispatch.initiatives.setCurrntNotesAsync(data);
        this.props.editOnHold(true, clickStatus);
    }

    render() {
        return (
            <Feed className={`issueMessage ${this.props.resolvedModal}`} >
                <Feed.Event className="pad_10">
                    <ImageAvater user={this.props.selectedActivityData.onHoldComments[0].accountUserId} />
                    <Feed.Content>
                        <Feed.Summary>
                            {this.props.selectedActivityData.onHoldComments[0].accountUserId.firstName} {this.props.selectedActivityData.onHoldComments[0].accountUserId.lastName} <span>has put this activity on hold</span>
                            <span className="pull-right">{momentDate(this.props.selectedActivityData.onHoldComments[0].onHoldDate)} </span>
                        </Feed.Summary>
                        <Feed.Date><span className="pull-right" style={{ textAlign: "right" }}> <MomentTime date={this.props.selectedActivityData.onHoldComments[0].onHoldDate} /> </span></Feed.Date>
                    </Feed.Content>
                </Feed.Event>
                <Divider className="mar_0" />
                <div className="pad_10">
                    <Labels
                        name={<div>Comment: <span className="pull-right">
                            {this.props.selectedActivityData.onHoldComments[0].accountUserId._id === this.props.user._id
                                && this.props.selectedActivityData.onHoldComments[0].isImplicitOnHold ?
                                <span className="clr-blue cursor-pointer" onClick={() => this.setCurrntNotes(this.props.selectedActivityData.onHoldComments[0], "editOnHoldComment")}>Edit</span> : ''}
                        </span>
                        </div>}
                        text={this.props.selectedActivityData.onHoldComments[0].comment}
                        htmlView={true}
                        className="bg-white" />
                </div>
            </Feed>
        )
    }
}

export default EditPutOnHoldCommentCard;


